import Stimp from "stimp/lib/index";
import { config } from "../../config";

export class BirdsSigning extends Stimp.DOMInteractModule {
  constructor(app, name, initState = {}, depends = []) {
    super(app, name, initState = {
      muted: true,
    }, depends);

    this.onAfterDomInit(() => {
      this.dom.buttonEnable.addEventListener('click', () => {
        this.setState({
          muted: false,
        });
      });

      this.dom.buttonMute.addEventListener('click', () => {
        this.setState({
          muted: true,
        });
      });
    });
  }

  onUpdateMuted(muted) {
    if (muted) {
      $(this.dom.contentEnabled).hide();
      $(this.dom.contentMuted).show();
    } else {
      $(this.dom.contentEnabled).show();
      $(this.dom.contentMuted).hide();
    }
    $(this.dom.video).prop('muted', muted);
  }
}